// extracted by mini-css-extract-plugin
export default {"placeholder":"ShapedPlaceholder-placeholder__iL8WW"};